import React from 'react';
import { Link as RRLink } from 'react-router-dom';
import { Link as TUILink } from 'theme-ui';

// A hacky component to get sx support on react router links
export const Link = ({ ...props }: any) => (
  <TUILink as={RRLink} variant="links.default" {...props} />
);
